// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AvatarSelectionModal.css */
.avatar-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .avatar-modal-overlay.show {
    opacity: 1;
  }
  
  .avatar-modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    position: relative;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .avatar-modal-content.show {
    opacity: 1;
  }
  
  .avatar-modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 3;
  }
  
  .close-icon {
    width: 24px;
    height: 24px;
  }
  
  .avatar-selection {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  
  .avatar-option {
    width: 80px;
    height: 100px;
    cursor: pointer;
    margin: 10px;
  }`, "",{"version":3,"sources":["webpack://./src/components/AvatarSelectionModal.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,YAAY;EACd","sourcesContent":["/* AvatarSelectionModal.css */\r\n.avatar-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n  }\r\n  \r\n  .avatar-modal-overlay.show {\r\n    opacity: 1;\r\n  }\r\n  \r\n  .avatar-modal-content {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    position: relative;\r\n    max-width: 90%;\r\n    max-height: 90%;\r\n    overflow: auto;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n  }\r\n  \r\n  .avatar-modal-content.show {\r\n    opacity: 1;\r\n  }\r\n  \r\n  .avatar-modal-close {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    z-index: 3;\r\n  }\r\n  \r\n  .close-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n  \r\n  .avatar-selection {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .avatar-option {\r\n    width: 80px;\r\n    height: 100px;\r\n    cursor: pointer;\r\n    margin: 10px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
